export default __webpack_public_path__ + "static/media/reports.bdbe3ade.svg";